import React, { useEffect, createRef, useState } from 'react';

import { Text, View, TouchableOpacity } from 'react-native';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { useInjectReducer } from '../../../utils/injectReducer'; // eslint-disable-line
import { useInjectSaga } from '../../../utils/injectSaga'; // eslint-disable-line
import { t } from '../../../services/i18n';

import reducer from './reducer';
import saga from './saga';
import makeSelectLoginBox from './selectors';
import { makeSelectNetworkIsConnected } from '../../../selectors';
import {
	changeInput, submitForm, unmount, tryLocalAuth, canLocalAuth, submitAuth, retreiveUser, submitSSO, ssoCompleted,
} from './actions';

import styles from './styles';
import Title from '../../../components/Content/Title';
import Input from '../../../components/Form/Input';
import Control from '../../../components/Control';
import login from '../../../services/login';
import Version from '../Version';
import Alert from '../../../services/alert';


import * as WebBrowser from 'expo-web-browser';
import * as AuthSession from 'expo-auth-session';
WebBrowser.maybeCompleteAuthSession();

import AUTHAPI from '../../../config/authAPI';
import API from '../../../config/api';

const key = 'loginbox';

// Redirect URI is generated by AuthSession.makeRedirectUri() below. Ensure the
// value matches what is registered in the identity provider.
function LoginBox({
	loginBox,
	handleChangeInput,
	handleSubmitForm,
	handleSubmitAuth,
	handleSSOCompleted,
	history,
	handleUnmount,
	handleTryLocalAuth,
	handleSubmitSSO,
	handleCanLocalAuth,
	isConnected,
}) {
	useInjectReducer({ key, reducer });
	useInjectSaga({ key, saga });
	//console.log(redirectUri, "redirectUri");
	const secondInput = createRef();
	const [isAuthShow, setIsAuthShow] = useState(false);

	const redirectUri = AuthSession.makeRedirectUri({
		scheme: 'safebuildings',
		pathname: 'auth',
	})
	const clientId = 'd79ed6fc-7d6e-44a6-be51-30140306aeac';
	// Discovery endpoints used as a fallback for AuthSession if loginDetails are missing.
	const discovery = {
		authorizationEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
		tokenEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/token/',
	};


	const {
		username, error, password, remember, loading, sent, terms, tryAuth, localAuthSupport, loginType, loginDetails, sso_Completed
	} = loginBox;

	// Only create auth request when we have valid URLs
	// This prevents "Invalid URL" errors when loginDetails are empty
	const hasValidUrls = loginDetails.auth_url && loginDetails.auth_url.trim() !== '' &&
		loginDetails.token_url && loginDetails.token_url.trim() !== '';

	// If there's no internet connection, then print an alert
	function checkConnectionBeforeSending(user, pass, remem) {
		//console.log(arguments)
		if (isConnected) {
			if (loginType == "oauth2") {
				// promptAsync();
			}
			else if (loginType == "local") {
				handleSubmitForm(user, pass, remem);
			}
			else {
				handleSubmitAuth(user, "", remem);
			}
		} else {
			Alert.alert(t('noInternetLoginTitle'), t('noInternetLoginMessage'));
		}
	}
	useEffect(() => {
		if (loginType == "oauth2" && hasValidUrls && promptAsync) {
			setTimeout(() => {
				handleSSOCompleted();
			}, 100);
		}
	}, [loginType, loginDetails, hasValidUrls])
	useEffect(() => {
		if (loginType == "oauth2" && hasValidUrls && sso_Completed && promptAsync) {
			promptAsync({
				showInRecents: true
			});
		}
	}, [sso_Completed, hasValidUrls])
	// If there's already an user in the securestorage, then populate the field
	async function setCreds() {
		const creds = await login.getCreds();
		if (creds) {
			handleChangeInput(creds.username, 'username');
		}
	}

	useEffect(() => {
		// on load, set the creds
		setCreds();
		return () => {
			// on unmount
			handleUnmount();
		};
	}, []);

	useEffect(() => {
		// If the form is correclyt sent
		if (sent) {
			// Send the user to the terms page if he haven't already validated it
			if (!terms) {
				// history.push('/', { page: 'terms' });
				history.push('/', { page: 'otpbox' });
			} else {
				history.push('/dashboard');
			}
		}
	}, [sent]);

	useEffect(() => {
		// On error change for match username/password, trigger an alert
		if (error.match) {
			Alert.alert(t('loginNoMatchTitle'), t('loginNoMatchMessage', { username }));
		}
	}, [error.match]);


	const [authRequest, result, promptAsync] =
		AuthSession.useAuthRequest(
			{
				clientId: loginDetails.client_id || clientId,
				scopes: loginDetails.scopes || ["openid", "email"],
				redirectUri,
				responseType: AuthSession.ResponseType.Code,
				// Force Azure/Microsoft to NOT reuse the cached SSO session
				// - prompt=login => always ask for credentials again
				// - prompt=select_account => show account picker (less strict)
				extraParams: {
					...({}),
					prompt: 'login',
					...({}),
				},
			},
			hasValidUrls ? {
				authorizationEndpoint: loginDetails.auth_url,
				tokenEndpoint: loginDetails.token_url
			} : discovery, // Pass undefined when URLs are invalid to prevent URL construction errors
		);
	// const [authRequest, result, promptAsync] = AuthSession.useAuthRequest(
	// 	{
	// 		clientId: loginDetails.client_id || clientId,
	// 		redirectUri,
	// 		scopes: loginDetails.scopes || ["openid", "email"],
	// 		usePKCE: true,
	// 		responseType: 'code',
	// 		extraParams: loginDetails.extraParams || {}
	// 	},
	// 	hasValidUrls ? {
	// 		authorizationEndpoint: loginDetails.auth_url,
	// 		tokenEndpoint: loginDetails.token_url
	// 	} : undefined, // Pass undefined when URLs are invalid to prevent URL construction errors
	// );


	const decodeIdToken = (idToken) => {
		// Example function to decode an ID token (specific to your identity provider)
		// You may need to use a library or service to decode the ID token
		// For example, Auth0 provides a library for this purpose
		// https://github.com/auth0/auth0-idtoken-verifier-js
		// Note: Decoding ID token on the client side is generally not recommended for production apps
		// In a production environment, the server should handle token validation and decoding
		// This is just a simplified example for educational purposes
		const base64Url = idToken.split('.')[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const decoded = JSON.parse(atob(base64));
		return decoded;
	};


	const getToken = async ({ authResponse, request }) => {
		console.debug({ authResponse, request }, "getToken parameters");

		try {
			const code = authResponse?.params?.code;
			const codeVerifier = request?.codeVerifier;
			const tokenUrl = loginDetails.token_url;
			console.debug(code, "authorization code", codeVerifier, "codeVerifier", tokenUrl, "tokenUrl", {
				grant_type: 'authorization_code',
				code,
				redirect_uri: redirectUri,
				client_id: loginDetails.client_id,
				code_verifier: codeVerifier,
			});
			if (!code || !codeVerifier) {
				throw new Error('Missing authorization code or code verifier');
			}

			// e.g. https://oauth2.googleapis.com/token

			const response = await fetch(tokenUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams({
					grant_type: 'authorization_code',
					code,
					redirect_uri: redirectUri,
					client_id: loginDetails.client_id,
					code_verifier: codeVerifier,
				}).toString(),
			});

			const result = await response.json();
			console.log(result, "result re");


			if (result.error) {
				console.error('OAuth Error:', result);
				throw new Error(result.error_description || 'Token exchange failed');
			}

			const accessToken = result.access_token;
			const idToken = result.id_token;
			console.log(idToken, "idToken");
			console.log(accessToken, "accessToken");
			if (!idToken) {
				throw new Error('Missing ID token');
			}

			const decodedIdToken = decodeIdToken(idToken);
			
			// Try multiple fields from ID token - different providers use different claims
			const userEmail = decodedIdToken?.email || 
			                  decodedIdToken?.preferred_username || 
			                  decodedIdToken?.upn || 
			                  decodedIdToken?.unique_name ||
			                  decodedIdToken?.sub; // fallback to subject if no email
			
			console.log('ID Token claims:', {
				email: decodedIdToken?.email,
				preferred_username: decodedIdToken?.preferred_username,
				upn: decodedIdToken?.upn,
				unique_name: decodedIdToken?.unique_name,
				allClaims: decodedIdToken
			});

			if (!userEmail) {
				throw new Error('Email or username not found in ID token');
			}

			// Normalize both values for comparison (trim whitespace, lowercase)
			const normalizeEmail = (email) => {
				if (!email) return '';
				return email.toString().trim().toLowerCase();
			};
			
			const normalizedUserEmail = normalizeEmail(userEmail);
			const normalizedUsername = normalizeEmail(username);
			
			console.log('Email comparison:', {
				userEmailFromToken: userEmail,
				usernameFromInput: username,
				normalizedUserEmail,
				normalizedUsername,
				match: normalizedUserEmail === normalizedUsername
			});

			// Compare normalized emails (case-insensitive, trimmed)
			if (normalizedUserEmail === normalizedUsername || !username) {
				// If username is empty, allow login (user might not have entered it yet)
				handleSubmitSSO(accessToken, loginDetails.locationId);
			} else {
				Alert.alert(
					'Account Mismatch', 
					`You are using a different account (${userEmail}) to login. Please use ${username || 'your registered email'}.`
				);
			}

			return result;

		} catch (error) {
			handleChangeInput(false, 'loading');
			console.error('SSO Token Error:', error);
		}
	};


	useEffect(() => {
		const handleAuthResult = async () => {
			console.debug(result, "result Data", authRequest, "authRequest Data");

			try {
				if (
					result?.type === 'success' &&
					result?.params &&
					result?.params.code &&
					result?.params.state === authRequest?.state &&
					authRequest?.codeVerifier
				) {
					await getToken({
						authResponse: result,
						request: authRequest,
					});;
				}
				else
				{
					console.log('Auth result does not meet criteria', result, authRequest);
				}
			} catch (error) {
				console.error('Error handling authentication result:', error);
			}
		};

		handleAuthResult();
	}, [result, authRequest]);

	return (
		<>
			<Title title={t('logIn')} />
			<Input
				value={username}
				placeholder={t('emailAddress')}
				onChangeText={(value) => handleChangeInput(value, 'username')}
				autoCompleteType="email"
				textContentType="username"
				autoCapitalize="none"
				keyboardType="email-address"
				returnKeyType="next"
				onSubmitEditing={() => checkConnectionBeforeSending(username, password, remember)}
				error={error.username}
			/>
			{loginType == "local" &&
				<Input
					value={password}
					placeholder={t('password')}
					onChangeText={(value) => handleChangeInput(value, 'password')}
					onSubmitEditing={() => checkConnectionBeforeSending(username, password, remember)}
					autoCompleteType="password"
					autoCapitalize="none"
					returnKeyType="done"
					returnKeyLabel={t('logIn')}
					textContentType="password"
					secureTextEntry
					error={error.password}
					ref={secondInput}
				/>
			}
			<View style={styles.forgotControlContainer}>
				<TouchableOpacity
					onPress={() => history.push({
						pathname: '/',
						state: {
							page: 'forgot',
						},
					})}
				>
					<Text style={styles.forgotControl}>{t('forgotPasswordControl')}</Text>
				</TouchableOpacity>
			</View>
			{/* 'Remember me' removed intentionally (token lifetime policy) */}
			<View style={styles.containerControls}>
				<View style={styles.controlLogin}>
					<Control
						loading={loading}
						title={t('logIn')}
						onPress={() => checkConnectionBeforeSending(username, password, remember)}
					/>
				</View>
			</View>
			<TouchableOpacity
				onPress={() => history.push({
					pathname: '/',
					state: {
						page: 'contact',
					},
				})}
			>
				<Text style={styles.contactControl}>{t('contactSafeBuildings')}</Text>
				<Version />
			</TouchableOpacity>
			{/* Local dev helpers removed for cleanliness */}
		</>
	);
}

const mapStateToProps = createStructuredSelector({
	loginBox: makeSelectLoginBox(),
	isConnected: makeSelectNetworkIsConnected(),
});

export function mapDispatchToProps(dispatch) {
	return {
		handleChangeInput: (value, name) => dispatch(changeInput(value, name)),
		handleSubmitForm: (username, password, remember) => dispatch(submitForm(username, password, remember)),
		handleSubmitAuth: (username) => dispatch(submitAuth(username)),
		handleSubmitSSO: (token, locationId) => dispatch(submitSSO(token, locationId)),
		handleSSOCompleted: () => dispatch(ssoCompleted()),
		handleUnmount: () => dispatch(unmount()),
		handleTryLocalAuth: () => dispatch(tryLocalAuth()),
		handleCanLocalAuth: (value) => dispatch(canLocalAuth(value)),
	};
}

const withConnect = connect(
	mapStateToProps,
	mapDispatchToProps,
);

export default compose(
	withConnect,
	withRouter,
	// memo,
)(LoginBox);
